import $ from 'jquery';
import slick from 'slick-carousel';
import config from '../app-config';

function setSliderPlans() {
    const plans = $('.aside-settings');

    plans.slick({
        dots: true,
        arrows: false,
        variableWidth: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        edgeFriction: 0,
        speed: 400,
        touchMove: false
    });
}


function init() {
    if ($('.aside-settings').length > 0 && $('html').width() <= 990) setSliderPlans();

    $('.aside-settings__item').on('click', function() {
        $('.aside-settings__item').removeClass('is-active');
        $(this).addClass('is-active');
    })
}

export {init};


// WEBPACK FOOTER //
// ./src/_app/layout/slider-aside-settings.js